<ng-container *ngIf="summary$$ | async as summary">
  <lohi-settlement-detail [statementId]="summary.id" [summary]="summary" [autoPrint]="true"></lohi-settlement-detail>
</ng-container>
